import { render, staticRenderFns } from "./supplierNameInput.vue?vue&type=template&id=38daa485"
import script from "./supplierNameInput.vue?vue&type=script&lang=js"
export * from "./supplierNameInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports